import { Injectable } from '@angular/core';
import { SchemaMetadataStore } from './schema-metadata.store';
import { SchemaMetadataQuery } from './schema-metadata.query';
import { BaseFacade } from '../base/base.facade';
import { SchemaMetadataService } from './schema-metadata.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SchemaMetadataModel } from './schema-metadata.model';
import { Content } from '../../squidex/index';

@Injectable({ providedIn: 'root' })
export class SchemaMetadataFacade extends BaseFacade {

  private readonly schemaMetaDataService: SchemaMetadataService;

  constructor(
    schemaMetadataService: SchemaMetadataService,
    schemaMetadataStore: SchemaMetadataStore,
    schemaMetadataQuery: SchemaMetadataQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(schemaMetadataService,
      schemaMetadataStore,
      schemaMetadataQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade('schemametadata'),
      translateService,
      'schemametadata-facade');

    this.schemaMetaDataService = this.getService() as SchemaMetadataService;
  }

  getByCategory(category: string): Observable<SchemaMetadataModel[]> {
    // TODO: store data
    return this.schemaMetaDataService.getByCategory(category).pipe(map(list => list.items));
  }


  getAll(): Observable<SchemaMetadataModel[]> {
    // TODO: store data
    return this.schemaMetaDataService.getAll().pipe(map(list => list.items));
  }

  getHiddenFields(schemaId: string): Observable<string[]> {
    return this.getBySchemaId(schemaId)
      .pipe(map(meta => (meta.data.hiddenfields.iv as string).split(';')
      ));
  }

  removeBySchemaId(id: string): Observable<SchemaMetadataModel> {
    return this.schemaMetaDataService.getBySchemaId(id).pipe(map(metaList => {

      const items = metaList.items as Content[];

      if (!items || !items[0]) {
        throw (new Error('Schema metadata doesn\'t exist'));
      }

      const firstItem = items[0];

      this.getService().removeContent(firstItem.id).toPromise().then(
        () => this.getStore().remove(id)
      );

      return firstItem;
    }));
  }

  hardRemoveBySchemaId(id: string): Observable<SchemaMetadataModel> {
    return this.schemaMetaDataService.getBySchemaId(id).pipe(map(metaList => {

      const items = metaList.items as Content[];

      if (!items || !items[0]) {
        throw (new Error('Schema metadata doesn\'t exist'));
      }

      const firstItem = items[0];

      this.getService().removeHardContent(firstItem.id).toPromise().then(
        () => this.getStore().remove(id)
      );

      return firstItem;
    }));
  }

  getBySchemaId(id: string): Observable<SchemaMetadataModel> {
    if (this.getQuery().getValue().ids.some(storedId => storedId === id)) {
      return this.getQuery().selectEntity(id);
    }

    return this.schemaMetaDataService.getBySchemaId(id)
      .pipe(map(list => {

        const items = list.items as Content[];

        if (!items) {
          throw (new Error('Schema metadata not found'));
        }

        const firstItem = items[0];

        this.getStore().add(firstItem);

        return firstItem;
      }));
  }
}
